// src/pages/LoginPage.tsx


import React, { Suspense, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useNotification } from '../context/NotificationContext'; // NOWY IMPORT

const LoginPageContent: React.FC = () => {
    const { login } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { showNotification } = useNotification(); // Używamy naszego hooka do powiadomień
    const [searchParams] = useSearchParams();
    console.log("Aplikacja łączy się z API pod adresem:", process.env.REACT_APP_API_URL);
    useEffect(() => {
        if (searchParams.get('verified') === 'true') {
            showNotification('Adres email został pomyślnie zweryfikowany! Możesz się teraz zalogować.', 'success');
        }
    }, [searchParams, showNotification]);

    const validationSchema = Yup.object({
        email: Yup.string().email(t('validation.emailInvalid')).required(t('validation.required')),
        password: Yup.string().required(t('validation.required')),
    });

    return (
        <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 bg-gray-800 p-10 rounded-xl shadow-lg">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
                        {t('login.title')}
                    </h2>
                </div>
                <Formik
                    initialValues={{ email: '', password: '' }}
                    validationSchema={validationSchema}
                    onSubmit={async (values, { setSubmitting }) => {
                        try {
                            const response = await api.post('/Auth/login', values);
                            login(response.data.token);
                            navigate('/');
                        } catch (error: any) {
                            // ZMIANA: Używamy showNotification zamiast alert
                            const errorMessage = error.response?.data?.message || t('login.authError');
                            showNotification(errorMessage, 'error');
                            setSubmitting(false);
                        }
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form className="mt-8 space-y-6">
                            <div className="rounded-md shadow-sm -space-y-px">
                                <div>
                                    <label htmlFor="email" className="sr-only">{t('common.email')}</label>
                                    <Field
                                        type="email"
                                        name="email"
                                        required
                                        className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-600 bg-gray-700 text-gray-200 placeholder-gray-400 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                        placeholder={t('common.email')}
                                    />
                                    <ErrorMessage name="email" component="p" className="text-red-400 text-xs italic mt-1" />
                                </div>
                                <div>
                                    <label htmlFor="password" className="sr-only">{t('common.password')}</label>
                                    <Field
                                        type="password"
                                        name="password"
                                        required
                                        className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-600 bg-gray-700 text-gray-200 placeholder-gray-400 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                        placeholder={t('common.password')}
                                    />
                                    <ErrorMessage name="password" component="p" className="text-red-400 text-xs italic mt-1" />
                                </div>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-indigo-400"
                                >
                                    {isSubmitting ? t('common.loading') : t('login.submitButton')}
                                </button>
                            </div>
                            <div className="text-sm text-center mt-4">
                                <Link to="/forgot-password" className="font-medium text-indigo-400 hover:text-indigo-300">
                                    {t('login.forgotPassword')}
                                </Link>
                            </div>
                        </Form>
                    )}
                </Formik>
                <div className="text-sm text-center">
                    <Link to="/register" className="font-medium text-indigo-400 hover:text-indigo-300">
                        Nie masz konta? Zarejestruj się
                    </Link>
                </div>
            </div>
        </div>
    );
};

const LoginPage = () => (
    <Suspense fallback={<div className="text-center p-8 text-white">Ładowanie...</div>}>
        <LoginPageContent />
    </Suspense>
);

export default LoginPage;
